module.exports = __webpack_public_path__ + "2b00c4f8bb9589d0fa4ddb16989c4e6d.pdf";